import { Link } from "react-router-dom";
import useFavorites from "@/hooks/useFavorites";
import { navSites } from "@/mocks/navSites";

export default function FavoritesStrip() {
  const { favorites } = useFavorites();
  const savedSites = favorites
    .map((id) => navSites.find((site) => site.id === id))
    .filter((site): site is NonNullable<typeof site> => Boolean(site))
    .slice(0, 4);

  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-4">
      <div className="flex items-center justify-between mb-3">
        <h2 className="flex items-center gap-1.5 font-heading font-bold text-sm text-foreground-950">
          <i className="ri-star-line text-accent-500" />
          我的收藏
        </h2>
        <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 text-[10px]">
          本地演示
        </span>
      </div>

      {savedSites.length === 0 ? (
        <div className="py-4 text-center">
          <p className="text-xs text-foreground-500 leading-5">
            还没有收藏的网址
            <br />
            在网址卡片右上角点击星标即可收藏
          </p>
          <Link
            to="/category/entertainment"
            className="inline-flex items-center gap-1 mt-3 text-xs text-primary-600 hover:text-primary-700 cursor-pointer"
          >
            去挑几个
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      ) : (
        <div className="space-y-1">
          {savedSites.map((site) => (
            <Link
              key={site.id}
              to={`/detail/${site.id}`}
              className="flex items-center gap-2 px-2 py-1.5 rounded-md hover:bg-background-100 cursor-pointer"
            >
              <span className="w-6 h-6 rounded bg-accent-50 text-accent-600 text-xs font-bold flex items-center justify-center">
                {site.letter}
              </span>
              <span className="text-xs text-foreground-800 truncate flex-1">{site.name}</span>
              <i className="ri-arrow-right-s-line text-foreground-300" />
            </Link>
          ))}
        </div>
      )}
      <p className="mt-3 pt-3 border-t border-background-100 text-[10px] text-foreground-400 leading-4">
        收藏保存在当前浏览器本地，仅用于功能演示，不支持跨设备同步，清除浏览器数据后会丢失。
      </p>
    </div>
  );
}